import React from 'react'
import styled from 'styled-components'
import { PoseGroup } from 'react-pose'

import Tile from './Tile'
import { AdminApp } from '@acorns/admin-framework-binding'
import { useAppsContext } from '../../contexts'

const Container = styled.div`
  display: grid;
  grid-auto-rows: minmax(100px, auto);
  grid-gap: 30px;
  grid-template-columns: repeat(auto-fill, minmax(285px, 1fr));
  margin-bottom: 40px;
  width: 100%;
`

const AppNavigator = () => {
  const { apps } = useAppsContext()

  return (
    <Container>
      <PoseGroup>
        {apps?.map((app: AdminApp, index: number) => (
          <Tile key={`${app.name}-${index}`} app={app} />
        ))}
      </PoseGroup>
    </Container>
  )
}

export { AppNavigator }
